import { render, staticRenderFns } from "./enduserDeclaration.vue?vue&type=template&id=bbdf188c"
import script from "./enduserDeclaration.vue?vue&type=script&lang=js"
export * from "./enduserDeclaration.vue?vue&type=script&lang=js"
import style0 from "./enduserDeclaration.vue?vue&type=style&index=0&id=bbdf188c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports